import React from "react";

import { formatear, vacio } from "./ConsultReportHelpers";

const ConsultReportSections = ({
    registro: r,
    ocultarVacios,
    enmascarar,
    secciones,
}) => {

    return (
        <div className="secciones">
            {secciones.map(([titulo, campos]) => {
                const llenos = campos.filter(([k]) => !vacio(r[k])).length;

                if (ocultarVacios && llenos === 0) return null;

                return (
                    <section className="seccion" key={titulo}>

                        <h2>
                            {titulo}
                            <small>
                                {llenos}/{campos.length}
                            </small>
                        </h2>

                        <dl>
                            {campos.map(([k, etiqueta, tipo]) => {
                                const v = r[k];
                                const esVacio = vacio(v);

                                if (ocultarVacios && esVacio) return null;

                                return (
                                    <div className="fila" key={k}>
                                        <dt>{etiqueta}</dt>
                                        <dd>
                                            {esVacio
                                                ? "—"
                                                : formatear(v, tipo, enmascarar)}
                                        </dd>
                                    </div>
                                );
                            })}
                        </dl>

                    </section>
                );
            })}
        </div>
    );
};

export default ConsultReportSections;
